import {Injectable} from "@angular/core";
import {RutasWebServices} from "../../services/rutasWebServices";
import {md5} from '../../services/md5';
import { HttpClient,HttpHeaders } from  '@angular/common/http';
import { tap, map, catchError } from "rxjs/operators";
import { GeneralServices } from 'src/services/generalServices';

@Injectable()
export class BusquedaGlobalService{
  
	constructor(private _http:HttpClient, private generalService: GeneralServices){}
	
	

  	getData(parametros:any, ruta: string){
		
		//this.generalService.showLoading('TXT_CARGANDO_DATOS_HC');
	
		let params=$.param(parametros);
		let rutasWS = new RutasWebServices();
		//let headers = new Headers({"Content-type":"application/x-www-form-urlencoded"});		
		/*return this._http.get(rutasWS.urlWebService(ruta)+'?'+params).map(res => {
			this.generalService.hideLoading();				
			return res.json()				
		});		*/

		return this._http.get(rutasWS.urlWebService(ruta)+'?'+params).pipe(
			map(res => res),
			tap(res => {
					//this.generalService.hideLoading();	
				},
				err => {
					//this.generalService.hideLoading();	
				})
		  )
	}	
 
}